import { ProductGallery } from "../Model/ProductGallery";
import { ProductRepository } from "../Repository/ProductRepository";

export interface UploadProductGaleryUseCase {
  invoke: (data: ProductGallery) => Promise<boolean>
}

export class UploadProductGallery implements UploadProductGaleryUseCase {
  private galleryRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.galleryRepo = _ProductRepo;
  }

   invoke(data: ProductGallery){
    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.galleryRepo.uploadProductGallery(data);
    return getData;
  }
}